export function ClassificationIdSelectWithAllDummy() {
	return (
		<div>
			<select id="employee-select-PagibigReport"></select>
		</div>
	);
}